import React, { forwardRef } from "react";
import { useI18n } from "./context";
import { languagePath, LANGUAGE_ORIGIN } from "./routes";
// The preview editor inserts transparent spans around dynamic text.
// Read only those spans as text so Hindi can use the complete sentence.
function textValue(child) {
    if (typeof child === "string" || typeof child === "number") return String(child);
    if (React.isValidElement(child) && child.props["data-ve-dynamic"] === "true" && child.props.style?.display === "contents") return textValue(child.props.children);
    return null;
}
function translatedChildren(children, t) {
    if (typeof children === "string") return t(children);
    if (Array.isArray(children)) {
        const parts = children.map(textValue);
        if (parts.every((part) => part !== null)) {
            const combined = parts.join("");
            const translated = t(combined);
            if (translated !== combined) return translated;
        }
        return children.map((child) => translatedChildren(child, t));
    }
    return children;
}
export const LocalizedContent = ({ value }) => {
    const { language, t } = useI18n();
    return language === "hi" ? translatedChildren(value, t) : value;
};
export const LocalizedElement = forwardRef(function LocalizedElement({ as: Tag, children, ...props }, ref) {
    const { language, t } = useI18n();
    if (language === "hi") {
        for (const key of ["alt", "title", "placeholder", "aria-label", "aria-description"]) if (typeof props[key] === "string") props[key] = t(props[key]);
        // Preserve the machine-readable value when the displayed option is translated.
        if (Tag === "option" && props.value === undefined && ["string", "number"].includes(typeof children)) props.value = children;
        if (Tag === "a" && typeof props.href === "string") {
            const href = props.href;
            const internal = href.startsWith("/") && !href.startsWith("//") || href.startsWith(LANGUAGE_ORIGIN + "/");
            if (internal) {
                const parsed = new URL(href, LANGUAGE_ORIGIN);
                if (!/^\/(?:api|admin|static|media|fonts|brand)(?:\/|$)/.test(parsed.pathname) && !/\.[a-z0-9]+$/i.test(parsed.pathname)) {
                    props.href = languagePath(parsed.pathname, language) + parsed.search + parsed.hash;
                }
            }
        }
    }
    return React.createElement(Tag, { ...props, ...(ref ? { ref } : {}) }, language === "hi" ? translatedChildren(children, t) : children);
});
